/**
 * No-op replacement for Next.js polyfill-module.
 * Modern browsers in our browserslist already support these APIs natively.
 */
export {};
